<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3 class="mt-5">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{$t('views.titles.resetPassword')}}</v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="elevation-1">
          <v-card-media :contain="true" src="/static/logo_ciclos.png" height="200px">
          </v-card-media>
          <v-card-text>
            <v-flex sm6 offset-sm3>
              <v-form @submit.prevent="send">
                <v-text-field :label="$t('attributes.email')" v-model="reset.email" :counter="100"
                  :error-messages="validationErrors.email">
                </v-text-field>
                <v-text-field :label="$t('attributes.password')" type="password" v-model="reset.password" :counter="20"
                  :error-messages="validationErrors.password">
                </v-text-field>
                <v-text-field :label="$t('attributes.confirm_password')" type="password" v-model="reset.password_confirmation"
                  :error-messages="validationErrors.password_confirmation" :counter="20">
                </v-text-field>

                <v-btn type="submit" block color="primary">{{$t('views.actions.send')}}</v-btn>

              </v-form>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data() {
      return {
        roles: [],
        validationErrors: {},
        reset: {
          email: '',
          password: '',
          password_confirmation: '',
          token: this.$route.params.token,
        },
      };
    },
    methods: {
      send() {
        this.$store.dispatch('sendReset', this.reset).then(() => {
          this.$toast.success(this.$t('messages.operationSuccess'));
          this.$router.push({
            name: 'login',
          });
        }).catch((error) => {
          this.validationErrors = error.response.data;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/features/auth/ResetPassword.vue